import React from 'react';
import './PresentCard.style.css';
import { Image, Text } from 'components';
import Formatter from 'utils/Formatter';

const PresentCard = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    cardRef,
    thumbnail,
    brand,
    barcode = null,
    barcodeImage = null,
    product,
    option = '',
    data,
  } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */

  /* ===== Function ===== */

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="jm-present-wrap">
      <div
        ref={cardRef}
        className={
          data?.is_amount === 'Y' ? 'jm-amount-card' : 'jm-present-card'
        }
      >
        <div className="jm-present-card-container">
          <div className="jm-present-image">
            <Image
              src={thumbnail}
              radius={10}
              width={'100%'}
              height={'100%'}
              crossOrigin="anonymous"
            />
          </div>

          <div className="jm-present-info">
            <Text size={18} color={'#666666'}>
              {brand}
            </Text>
            <Text size={24} weight={700} style={{ fontFamily: 'Pretendard' }}>
              {product}
            </Text>
            {option ? <Text color={'#66666699'}>{option}</Text> : null}
          </div>

          {barcode ? (
            <div className="jm-present-barcode">
              <img src={barcodeImage} alt={barcode} />

              <Text style={{ textAlign: 'center', paddingTop: 8 }}>
                {Formatter.membership(barcode)}
              </Text>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PresentCard;
